import React, { useEffect, useState } from 'react'
import delet from '../../../Assets/Images/delete.svg';
import edit from '../../../Assets/Images/edit.svg';
import Popup from 'reactjs-popup';
import Pagination from '../../Pagination/Pagination';
import { Link, useParams } from 'react-router-dom';
import { useCareers } from '../../../Context/CareersContext';
import { toast, ToastContainer } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import DeletModal from '../../DeleteModel/DeletModal';

function AllCareersTable() {
    const { getCareers, isCareers, deleteCareer } = useCareers();
    const { lang } = useParams();

    useEffect(() => {
        getCareers(lang);
    }, []);

    const handleDeleteCareer = async (id) => {
        try {
          await deleteCareer(id, lang);
          toast.success("Career deleted successfully!");
        } catch (error) {
          toast.error("Error deleting Career!");
          console.error("Error deleting Career:", error);
        }
      };
    return (
        <div className='bg-[#fff] rounded-2xl p-3'>
                  {!isCareers && <LoadingOverlay />} {/* Display loading overlay */}
            <table className='w-full border-collapse mb-6'>
                <thead>
                    <tr className='p-2'>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '20%' }}>SN</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '30%' }}>Name</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '30%' }}>Status</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '30%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {isCareers?.data?.map((career, index) => (
                        <tr key={index}>
                            <td className='p-5 text-start' style={{ width: '20%' }}>{String(index + 1).padStart(2, '0') + "."}</td>
                            <td className='p-5 text-start' style={{ width: '30%' }}>{career.title}</td>
                            <td className='p-5 text-start' style={{ width: '30%' }}>
                                <div className={career.status == 1 ?
                                    'bg-[#0966AE] text-[#fff] p-2 w-[75px] rounded-md border text-center' :
                                    'bg-[#ffc107] p-2 w-[75px] rounded-md border text-center'}>
                                    {career.status == 1 ? "Publish" : "Draft"}
                                </div></td>
                            <td className='p-5 text-center' style={{ width: '30%' }}>
                                <div className='flex gap-2 items-center'>
                                    <Link to={`/Careers/EditCareer/${career.id}`}>
                                        <div className='bg-[#148342] p-2 w-[40px] cursor-pointer rounded-md border'>
                                            <img src={edit} alt="" />
                                        </div>
                                    </Link>
                                    <Popup
                                        trigger={
                                            <div className='bg-[#AF1F24] p-2 w-[40px] cursor-pointer rounded-md border'>
                                                <img src={delet} alt="" />
                                            </div>
                                        }
                                        modal
                                        nested
                                    >
                                        {(close) => (
                                            <div className="modal">
                                                <DeletModal close={close} id={career.id} onDelete={() => handleDeleteCareer(career.id)} />
                                            </div>
                                        )}
                                    </Popup>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
        </div>
    );
}

export default AllCareersTable